import { handleStaleAssetFailure, isChunkLoadError, isScriptLoadError } from '@/helpers/appVersion';

export const registerStaleAssetHandlers = (): void => {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) {
      return;
    }

    handleStaleAssetFailure();
    event.preventDefault();
  });

  window.addEventListener('error', (event) => {
    if (!isScriptLoadError(event)) {
      return;
    }

    handleStaleAssetFailure();
  });
};
